import type { FaireProductEntity } from "../../entity_types/product";

export const p_qta4pabh94: FaireProductEntity = {
  token: "p_qta4pabh94",
  type: "product",
  name: "Candlefish Heirloom 12 oz Candle",
  brandToken: "b_8zt5xb283v",
  brandName: "Candlefish",
  imageUrl:
    "https://cdn.faire.com/fastly/b92e74541baceb191c640effd8e9bef201dd0f82ae96f28e9cce34d9d088a961.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de9bd694a06baece624336f9d36bde0dce733836e854a8fc4996f2e43b506a93.jpeg",
  ],
  priceDollars: 22,
  description:
    "Recall summers past with the Heirloom candle, where the air was thick with the familiar aroma of heirloom tomatoes, evoking cherished memories of sunlit gardens and simple, heartwarming meals. This distinctive fragrance wraps around you like a cozy blanket—a sweet embrace of nostalgia. Infused with the fresh, herbal notes of basil, the floral essence of geranium, and the green, earthy scent of tomato leaves, this candle brings back the warmth and simplicity of bygone days.\n\nSoy wax\n12 oz candle\nFragrance Notes: Tomato Leaves, Geranium, Basil\nFragrance Family - Spice & Herb\n\nIdeal gift giving with Candlefish: Easter decor, Easter baskets, Mother's Day gifts, Father's Day gifts, graduation gifts, fall candles, holiday candles, Christmas candles, Christmas gifts. ",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:56.362Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
